import React from 'react';

// components
import {CardBorder} from '../CardBorder';

// styles
import {
  CardEmptyStateContent,
  CardEmptyStateWrapper,
} from './CardEmptyState-styles';
import {Subtitle, TitleLarge} from '../../styles';

// types
type Props = {
  title?: string;
  text: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

const CardEmptyState = ({title, text, icon: IconComponent}: Props) => {
  return (
    <CardBorder variant="white">
      <CardEmptyStateWrapper>
        {title && <Subtitle bold="bold">{title}</Subtitle>}
        <CardEmptyStateContent>
          {IconComponent && <IconComponent />}
          <TitleLarge>{text}</TitleLarge>
        </CardEmptyStateContent>
      </CardEmptyStateWrapper>
    </CardBorder>
  );
};

export default CardEmptyState;
